import { extractColumns, getAgGridColId, type Column } from '@talos/kyoko';
import { compact } from 'lodash-es';
import type { MarketSelectorColumnContribution } from '../types';

/** This function returns how much width to add to the Panel dropdown based on what enrichment columns we'll be showing to the user */
export function getAdditionalPanelWidthFromContributions(
  advancedMode: boolean,
  contributions: MarketSelectorColumnContribution[]
): number {
  const columnsByColID = new Map<string, Column>();
  contributions.forEach(spec => extractColumns(spec.columns).forEach(c => columnsByColID.set(getAgGridColId(c), c)));

  const simpleModeColIDs = compact(
    contributions.flatMap(spec => (advancedMode ? spec.advancedModeVisibleColIDs : spec.simpleModeVisibleColIDs))
  );
  const additionalWidth = simpleModeColIDs.reduce((total, colID) => {
    const column = columnsByColID.get(colID);
    return total + (column?.width ?? 100); // arbitrary defaulting... i think this is fine, this'll be manageable
  }, 0);

  return additionalWidth;
}

export function hasAdvancedOnlyColumns(contributions: MarketSelectorColumnContribution[]) {
  return contributions.some(contribution => {
    const simpleColumnIDs = new Set(contribution.simpleModeVisibleColIDs ?? []);
    return contribution.advancedModeVisibleColIDs.some(columnID => !simpleColumnIDs.has(columnID));
  });
}
